module.exports = __webpack_public_path__ + "static/img/11.3de8ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/11.png
// module id = kYDB
// module chunks = 0